import PaymentMethodCard from "./paymentMethodCard.container";

export default PaymentMethodCard;
